export const GOOGLE_MAP_URL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization";

export const mockExport = "";

export const EMPTY_DASH = "—";



// WEBPACK FOOTER //
// ./src/constants.js